import React from 'react';
import classes from "./style.module.scss";
import { Icons, Images } from '../../../../assets';



const ExternalNavbar = () => {

    return (
        <>
            <div className={`relative ${classes.navWrapper}`}>
                <div className={`${classes.navHeader} w-[100%] flex items-center justify-between`}>
                    <div className={`${classes.appLogoContainer}`}>
                        <img src={Icons.kgLogo} className={`${classes.appLogo}`} />
                    </div>
                </div>
                <div>
                    <img src={Images.colorBar} className={`${classes.colorBar}`} />
                </div>
            </div>
        </>
    );
}

export default ExternalNavbar